import { FC } from "react";
import LoadingSvg from "@/assets/images/loading.svg";

export const Loading: FC = () => {
  return (
    <>
      <div className="absolute bottom-0 left-0 right-0 top-0 bg-black opacity-50" />
      <div className="absolute bottom-0 left-0 right-0 top-0 flex items-center justify-center">
        <img src={LoadingSvg} className="h-[30px] w-[30px]" />
      </div>
    </>
  );
};
